import { Injectable, inject } from '@angular/core';
import { MainMenuItem } from '../main-menu';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class MainMenuItemService {

    private rtr = inject(Router);

    isActiveRouteString(path: string[]): boolean {
        if (path?.length > 0) {
            let pathElements = '';
            for (const rl of path) {
                if (pathElements != '') {
                    pathElements += '/';
                }
                pathElements += rl;
            }
            return this.rtr.isActive(pathElements, {
                paths: 'subset',
                queryParams: 'subset',
                fragment: 'ignored',
                matrixParams: 'ignored',
            });
        }
        return false;
    }

    isActiveRoute(mmi: MainMenuItem): boolean {
        for (const smi of mmi.subMenuItems) {
            if (this.isActiveRouteString(smi?.phitoRoute?.getRoute())) {
                return true;
            }
        }
        return false;
    }
}
